export default __webpack_public_path__ + "static/rec-2019-ii-1fb5dfad122b251ac152098f8dffeaae.png";